import {Injectable, Injector, OnDestroy} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpService} from 'projects/core/src/public-api';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {ProductionPlanningEvent} from './production-planning-event';
import {Any} from 'json2typescript';
import {ProductionPlanningPost} from './production-planning-post';
import {ActivityForEdit} from "../../admin-panel/data/activityi-for-edit";


@Injectable({
  providedIn: 'root',
})
@RxJSUnsubscribe
export class ProductionPlanningProjectsService extends HttpService implements OnDestroy, RxJSUnsubscribable {

  prodPlanActivitiesSubj = new Subject<string[]>()

  constructor(
    protected injector: Injector,
    protected appStateQuery: AppStateQuery,
    protected wsService: WsService
    // protected timeCardsStore: TimeCardsStore
  ) {
    super(injector);
  }

  getEvents(dateFrom: string, dateTo: string): Observable<ProductionPlanningEvent[]> {
    return this.getData(`/production-planning/load/${dateFrom}:${dateTo}`, ProductionPlanningEvent);
  }

  getActivityTypeByPostId(postId: number): Observable<ActivityForEdit[]> {
    return this.getData(`/production-planning/post/${postId}/activity-types`, ActivityForEdit);
  }

  moveWithinWeek(activityId: number, postId: number, currentWeekStart: string, pos: number): Observable<any> {
    return this.putData(`/production-planning/post/move-activity`, {
      activityId,
      postId,
      pos,
      currentWeekStart,
    }, Any);
  }

  moveToAnotherWeek(activityId: number, postId: number, currentWeekStart: string, targetWeekStart: string): Observable<any> {
    return this.putData(`/production-planning/post/move-activity`, {
      activityId,
      postId,
      currentWeekStart,
      targetWeekStart,
      pos: 0,
    }, Any);
  }

  // updateEvent(timeCard: TimeCard): Observable<TimeCard> {
  //   return this.putData(`/production-planning/post`, timeCard, TimeCard)
  // }

  ngOnDestroy() {

  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

}
